module.exports = "../images/fishing-lodge-2-4.jpg?v=c6a4872";